import { User } from "../auth"

export interface ErkomItemFollowUp {
	date: Date
	state: string
	user: User | string
}
